module.exports = "<div class=\"uic_login\">\r\n    <!-- ko if: loginTemplate == \"default\" -->\r\n    <default-login></default-login>\r\n    <!-- /ko -->\r\n\r\n    <!-- ko if: loginTemplate == \"concise\" -->\r\n    <concise-login></concise-login>\r\n    <!-- /ko -->\r\n\r\n    <!-- ko if: loginTemplate == \"smallConcise\" -->\r\n    <small-concise-login></small-concise-login>\r\n    <!-- /ko -->\r\n</div>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/tabLogin/TabLogin.html
// module id = 109
// module chunks = 0